import {errorHandler} from "./common";
const axios = require('axios');

export function getDocument(id) {
  return new Promise(function(resolve, reject) {
    axios.get(process.env.ROOT_API + 'admin/document?id=' + id,  {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      let data = response.data;
      resolve(data);
    }).catch(function(err) {
      errorHandler(err);
      reject(err);
    })
  })
}
export function getDocuments(requestId, type) {
  return new Promise(function(resolve, reject) {
    axios.get(process.env.ROOT_API + 'admin/documents?requestId=' + requestId + "&type=" + type,  {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      let data = response.data;
      resolve(data);
    }).catch(function(err) {
      errorHandler(err);
      reject(err);
    })
  })
}
export function updateDocument(document) {
  return new Promise(function(resolve, reject) {
    axios.post(process.env.ROOT_API + 'admin/document', JSON.stringify(document),  {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      let data = response.data;
      resolve(data);
    }).catch(function(err) {
      errorHandler(err);
      reject(err);
    })
  })
}
export function deleteDocument(id) {
  return new Promise(function(resolve, reject) {
    axios.delete(process.env.ROOT_API + 'admin/document?id='+ id,  {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      let data = response.data;
      resolve(data);
    }).catch(function(err) {
      errorHandler(err);
      reject(err);
    })
  })
}
export function createNewDocument(requestId, type) {
  let item = {
    id:0,
    requestId:requestId,
    type:type,
    url:'',
    title:'',
    description:'',
  }
  return item;
}
export function getDocumentTypeList() {
  let list = [
    {
      title:'참고문서',
      value:'info_document',
    },
    {
      title:'일반문서',
      value:'document',
    },
    {
      title:'미디어',
      value:'media',
    }
  ];
  return list;
}



// WEBPACK FOOTER //
// ./src/api/documents.js